import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';


const getRandomGreenColor = () => {
  const colors = [
    'rgba(76, 175, 80, 1)',  // fully opaque
    'rgba(76, 175, 80, 0.8)',  // slightly less opaque
    'rgba(76, 175, 80, 0.6)',  // even lighter
    'rgba(76, 175, 80, 0.4)',  // lighter still
    'rgba(76, 175, 80, 0.3)'   // very light
  ];  return colors[Math.floor(Math.random() * colors.length)];
};

const getRandomColor = () => {
  const colors = ['#FF6347', '#FF4500', '#FF7F7F', '#FFB6B6', '#FFA07A'];
  return colors[Math.floor(Math.random() * colors.length)];
};

const WordCloudSection = ({ positiveWords, negativeWords, positiveSentences, translatedWords,translatedSentences }) => {
  const [currentPositiveIndex, setCurrentPositiveIndex] = useState(0);
  const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0);
  const [language, setLanguage] = useState('original');

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPositiveIndex((prevIndex) => (prevIndex + 1) % positiveWords.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [positiveWords.length]);

  useEffect(() => {
    const sentenceInterval = setInterval(() => {
      setCurrentSentenceIndex((prevIndex) => (prevIndex + 1) % positiveSentences.length);
    }, 5000);
    return () => clearInterval(sentenceInterval);
  }, [positiveSentences.length]);

  const nextWord = () => {
    setCurrentPositiveIndex((prev) => (prev + 1) % positiveWords.length);
    setCurrentSentenceIndex((prev) => (prev + 1) % positiveSentences.length);
  };

  const previousWord = () => {
    setCurrentPositiveIndex((prev) => (prev - 1 + positiveWords.length) % positiveWords.length);
    setCurrentSentenceIndex((prev) => (prev - 1 + positiveSentences.length) % positiveSentences.length);
  };

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const getDisplayWords = (wordsArray, wordType) => {
    if (language === 'original') {
      return wordsArray;
    }
    const translatedArray = translatedWords[`${wordType}_${language}`];
    if (translatedArray && translatedArray.length > 0) {
      return translatedArray.map((text, index) => ({
        text,
        color: wordsArray[index].color,
        value: wordsArray[index].value
      }));
    }
    return wordsArray;
  };

  const getDisplaySentences = () => {
    if (language === 'original') {
      return positiveSentences;
    }
    return translatedSentences[language] || positiveSentences;
  };
  const displayPositiveWords = getDisplayWords(positiveWords, 'positive');
  const displayNegativeWords = getDisplayWords(negativeWords, 'negative');
  const displaySentences = getDisplaySentences();


  return (
    <div className="flex flex-col items-center justify-center bg-transparent px-4 md:px-6 mb-8 ">
          
      {/* Language selector */}
      <div className="mr-0 md:mr-auto relative flex items-center">
  {/* Logo */}
  <img src="./bhashni_logo.png" alt="Logo" className="h-8 w-8 mr-2" />

  {/* Select Dropdown */}
  <select
    value={language}
    onChange={handleLanguageChange}
    className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
  >
    <option value="">Choose a language</option>
    <option value="en">English</option>
    <option value="hi">Hindi</option>
    <option value="kn">Kannada</option>
  </select>

  {/* Dropdown Icon */}
  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.574 4.343 8 12.954 14.293z"/>
    </svg>
  </div>
</div>


      <div className="bg-white p-6 md:p-4 max-w-full md:max-w-7xl w-full grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Positive Words Card */}
        <div className="bg-white p-6 md:p-8 rounded-xl shadow-md relative">
          <h1 className="text-2xl md:text-4xl font-bold bg-custom-gradient bg-clip-text text-transparent mb-6 text-left">
          Person-First Cues
          </h1>
          <div className="flex justify-between items-center mb-4 md:mb-8">
            <div className="flex items-center space-x-2">
              <div className="bg-[#30507F] text-white rounded-full px-2 md:px-3 py-1 text-xs md:text-sm font-bold">
                {currentPositiveIndex + 1}
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#30507F]">
                {displayPositiveWords[currentPositiveIndex].text}
              </h2>
            </div>
            <div className="flex space-x-2">
              <div className="bg-gray-200 rounded-full p-2 cursor-pointer" onClick={previousWord}>
                <FaChevronLeft />
              </div>
              <div className="bg-gray-200 rounded-full p-2 cursor-pointer" onClick={nextWord}>
                <FaChevronRight />
              </div>
            </div>
          </div>

          <motion.div
            key={currentSentenceIndex}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 1 }}
            className="p-4 bg-[#F5FAF3] text-[#358534] rounded-md text-center mb-6 md:mb-8 text-base md:text-lg"
          >
            {displaySentences[currentSentenceIndex]}
            </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4">
          <AnimatePresence initial={false}>
          {displayPositiveWords.map((wordObj, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.5 }}
                  className="relative text-sm md:text-lg lg:text-xl font-semibold text-center p-2  group"
                  style={{
                    color: index === currentPositiveIndex ? '#358534' : getRandomGreenColor(),  // Dark color for the underlined word
                  }}                >
                  <div className="truncate" >{wordObj.text}</div>
                    {/* Tooltip */}
  <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 translate-y-2 bg-black text-white text-xs md:text-sm p-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
    {wordObj.text}
  </div>
                  {index === currentPositiveIndex && (
                    <motion.div
                      className="absolute bottom-0 left-0 right-0 h-0.5 bg-green-500"
                      initial={{ width: '0%' }}
                      animate={{ width: '90%' }}
                      transition={{ duration: 1.5, ease: 'easeInOut' }}
                    />
                  )}
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </div>

        {/* Negative Words Card */}
        <div className="bg-white p-6 md:p-8 rounded-xl shadow-md relative">
        <h1 className="text-2xl md:text-4xl font-bold bg-custom-gradient bg-clip-text text-transparent mb-6 text-left">
        Words to Avoid
          </h1>
          <div className="flex justify-between items-center mb-4 md:mb-8">
            <div className="flex items-center space-x-2">
              <div className="bg-[#30507F] text-white rounded-full px-2 md:px-3 py-1 text-xs md:text-sm font-bold">
                {currentPositiveIndex + 1}
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#30507F]">
                {displayNegativeWords[currentPositiveIndex].text}
              </h2>
            </div>
            <div className="flex space-x-2">
              <div className="bg-gray-200 rounded-full p-2 cursor-pointer" onClick={previousWord}>
                <FaChevronLeft />
              </div>
              <div className="bg-gray-200 rounded-full p-2 cursor-pointer" onClick={nextWord}>
                <FaChevronRight />
              </div>
            </div>
          </div>
          {/* <motion.div
            key={currentSentenceIndex}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 1 }}
            className="p-4 bg-[#FAEAEA] text-[#D13C3C] rounded-md text-center mb-6 md:mb-8 text-base md:text-lg"
          >
            Negative emotions like sadness, anger, and frustration are normal responses to a diagnosis of kidney disease.
          </motion.div> */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4">
          <AnimatePresence initial={false}>
          {displayNegativeWords.map((wordObj, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.5 }}
                  className="relative text-sm md:text-lg lg:text-xl font-semibold text-center p-2 overflow-hidden"
                  style={{
                    color: index === currentPositiveIndex ? '#FF4500' : getRandomColor(),  // Dark color for the underlined word
                  }}   
                >
                  <div className="truncate">{wordObj.text}</div>
                  {index === currentPositiveIndex && (
                    <motion.div
                      className="absolute bottom-0 left-0 right-0 h-0.5 bg-red-500"
                      initial={{ width: '0%' }}
                      animate={{ width: '90%' }}
                      transition={{ duration: 1.5, ease: 'easeInOut' }}
                    />
                  )}
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WordCloudSection;